export default __webpack_public_path__ + "static/tab-team-1751fec29d7adb3a5c63fdaf36e9f09c.png";